<template>
  <article
    class="base-placeholder base-placeholder--no-results"
    role="status"
    aria-live="polite"
  >
    <div class="base-placeholder__icon">
      <icon-base icon="search" :fontIcon="true" />
    </div>

    <div class="base-placeholder__body">
      <h4 class="mb-2 appMain--text">{{ `No ${entity} found.` }}</h4>

      <slot>
        <p>
          No results found for the following search criteria:<br />
          <i class="appMain light--text pl-1 pr-1">{{ search }}</i>
        </p>
      </slot>

      <div class="base-placeholder__actions">
        <v-btn v-if="clear" color="appMain" @click="clear">
          {{ clearButtonText }}
        </v-btn>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PlaceholderNoResults',
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      icon: 'mdi-magnify-close',
      fontIcon: '',
      title: 'No Results',
      text: '',
      create: null,
      clear: null,
      clearButtonText: 'Clear Search',
      search: '',
      button: '',
      entity: '',
    };
  },
  mounted() {
    for (let key in this.config) {
      if (this.hasOwnProperty(key)) {
        this[key] = this.config[key];
      }
    }
  },
};
</script>
